<template>
  <v-container>
    <h2>Request Module License</h2>
    <v-form @submit.prevent="submitForm">
      <v-card class="pa-4">
        <v-text-field
          v-model="licenseReq.practice"
          label="Practice Name"
          variant="outlined"
          :rules="[(v) => !!v || 'Practice name is required']"
        ></v-text-field>

        <v-text-field
          v-model="licenseReq.phone"
          label="Phone Number"
          variant="outlined"
          :rules="[(v) => !!v || 'Phone is required']"
        ></v-text-field>

        <v-select
          v-model="licenseReq.module"
          :items="modules"
          label="Module"
          variant="outlined"
          :rules="[(v) => !!v || 'Module is required']"
        ></v-select>

        <v-textarea
          v-model="licenseReq.comment"
          label="If this is a name or phone number change, please enter the old information here"
          variant="outlined"
          rows="3"
          placeholder="Optional comment..."
        ></v-textarea>

        <v-alert
          v-if="errorMessage"
          type="error"
          dismissible
          class="mt-2"
          @click:close="errorMessage = ''"
        >
          {{ errorMessage }}
        </v-alert>

        <v-card-actions class="justify-end">
          <v-btn color="primary" type="submit" :loading="loading"> Request License</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const loading = ref(false);
const errorMessage = ref('');

const modules = [
  'DEXray9',
  'DEXnet',
  'DEXlink',
  'DEXimage',
  'DEXwrite',
  'DEXimplant',
  'DEXscan',
  'DEXpan',
  'DEXpsp',
  'IO-Sensor',
  'Kodak3D',
  'XD-RayScan',
  'XD-F1',
  'XD-Impression',
  'XD-go',
  'XD-Control',
  '3DImport',
  'VolExport',
  'DEXcom',
  'DEXsecurity',
  'DEXsync',
];

const licenseReq = ref({
  practice: '',
  phone: '',
  module: '',
  comment: '',
});

const prefillFromUrlParams = () => {
  const { practice, phone, comment } = route.query;

  if (practice) {
    licenseReq.value.practice = practice;
  }

  if (phone) {
    licenseReq.value.phone = phone;
  }

  if (comment) {
    licenseReq.value.comment = comment;
  }
};

onMounted(() => {
  prefillFromUrlParams();
});

const submitForm = async () => {
  try {
    loading.value = true;
    errorMessage.value = ''; // Clear any previous error
    await axios.post('/api/module-licenses', licenseReq.value);
    // Handle success (e.g., show success message, redirect, etc.)
    setTimeout(() => {
      router.push({ name: 'module-license-list' });
    }, 500);
  } catch (error) {
    console.error('Error submitting form:', error);

    // Handle different error scenarios
    if (error.response?.status === 400) {
      const fullMessage =
        error.response.data?.message || 'Invalid input data. Please check your entries.';
      const problemIndex = fullMessage.indexOf('problem: ');
      errorMessage.value =
        problemIndex !== -1
          ? fullMessage.substring(problemIndex + 9) // Extract text after "problem: "
          : fullMessage;
    } else if (error.response?.status === 500) {
      errorMessage.value = 'Server error. Please try again later.';
    } else if (error.response) {
      errorMessage.value = error.response.data?.message || `Error: ${error.response.status}`;
    } else if (error.request) {
      errorMessage.value = 'Network error. Please check your connection and try again.';
    } else {
      errorMessage.value = 'An unexpected error occurred. Please try again.';
    }
  } finally {
    loading.value = false;
  }
};
</script>
